<template>
  <div></div>
</template>

<script>
import {USER_TYPE} from "@/common/lib/config";

export default {
  name: "dashboard",
  mounted() {
    const {staffType} = this.loginInfo;
    this.$router.replace(USER_TYPE[staffType] && USER_TYPE[staffType].defaultIndex)
  }
}
</script>

<style scoped>

</style>
